import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { ApolloProvider } from '@apollo/client/react'
import apolloClient from './clients/apollo'

import App from './App'
import reportWebVitals from './reportWebVitals'

Sentry.init({
  dsn: 'https://b5dfaf5eebba4e2ead0e3cd20756e275@o1066530.ingest.sentry.io/6059341',
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.NODE_ENV || 'production',

  beforeSend: (event) => {
    if (window && window.location.hostname === 'localhost') {
      return null
    }
    return event
  },

  // Set tracesSampleRate to 1.0 to capture 100
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 0.05
})

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
